import habitat from 'preact-habitat';
import Widget from './components/widget';
import './styles/index.scss';
var _habitat = habitat(Widget);
_habitat.render({
    selector: '[fmc-widget-name="fmc-request-form"]',
    clean: true,
});
